export const SHIPPING_LOCATION = '_shipping_location';
export const CONCENT_REQUIRED = '_cookie_required';
export const CONCENT_PREFERENCES = '_cookie_preferences';
export const CONCENT_MARKTING = '_cookie_markting';
export const CONCENT_STATISTICS = '_cookie_statistics';
export const ADVANCED_VIEW_ACTIVE = '_advanced_view_active';
export const DETAILED_PRICES = 'detail_prices';
export const IS_PSA = 'is_psa';
export const SERVICEBOX_COOKIE = 'servicebox';
export const SEPA_MODAL_DISMISSED = 'sepa_modal_dismissed';

